import { render } from "./VideoItem.vue?vue&type=template&id=40366ac4&scoped=true"
import script from "./VideoItem.vue?vue&type=script&lang=js"
export * from "./VideoItem.vue?vue&type=script&lang=js"

import "./VideoItem.vue?vue&type=style&index=0&id=40366ac4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40366ac4"]])

export default __exports__